"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PrevNextButton = exports.PlayPauseButton = exports.DotsNavigation = exports.StageItem = exports.SlideInfo = void 0;

var SlideInfo_1 = require("./SlideInfo"),
    StageItem_1 = (Object.defineProperty(exports, "SlideInfo", {
  enumerable: !0,
  get: function () {
    return SlideInfo_1.SlideInfo;
  }
}), require("./StageItem")),
    DotsNavigation_1 = (Object.defineProperty(exports, "StageItem", {
  enumerable: !0,
  get: function () {
    return StageItem_1.StageItem;
  }
}), require("./DotsNavigation")),
    PlayPauseButton_1 = (Object.defineProperty(exports, "DotsNavigation", {
  enumerable: !0,
  get: function () {
    return DotsNavigation_1.DotsNavigation;
  }
}), require("./PlayPauseButton")),
    PrevNextButton_1 = (Object.defineProperty(exports, "PlayPauseButton", {
  enumerable: !0,
  get: function () {
    return PlayPauseButton_1.PlayPauseButton;
  }
}), require("./PrevNextButton"));

Object.defineProperty(exports, "PrevNextButton", {
  enumerable: !0,
  get: function () {
    return PrevNextButton_1.PrevNextButton;
  }
});